<template>
    <div class="text-center">
        <v-dialog
        v-model="dialog"
        width="500"
        >
            <v-card>
                <v-card-title :class="getColorStyle">
                {{ textTitle }}
                </v-card-title>
              
                <v-img :src="getIcon"  style="display: block; margin: 0 auto; width: 25%; height: 25%; "></v-img>  
                <v-card-text class="pt-2 body-3 headline text-center align-center"><span :class="getColorText">{{ statusDevice }}</span></v-card-text>
                <div style="margin-left: 4%;">
                <v-card-text class="pt-3 body-1 font-weight-medium" >
                    Se presiónó el botón de pánico "<span class="font-weight-bold">{{ device.name }}</span>" de la estación "<span class="font-weight-bold">{{ device.station }}</span>".
                </v-card-text>
            </div>
            <div style="display: flex; justify-content: space-around;">
                 <div>
                    <v-card-text class="pt-3 body-1 font-weight-medium">Cedula: <span class="font-weight-bold">1076904331</span>.</v-card-text>
                 </div>
            <div>
                    <v-card-text class="pt-3 body-1 font-weight-medium">Email: <span class="font-weight-bold">example@hotmail.com</span>.</v-card-text>
                </div>
            </div>

            <div style="display: flex;  ">
              <div style="margin-left: 4%;">
                 <v-card-text class="pt-3 body-1 font-weight-medium">Fecha: <span class="font-weight-bold">{{ device.lastUpdate |  formatDateShort }}</span></v-card-text>
              </div>
            
            </div>
            <div style="margin-left: 4%;">
                 <v-card-text class="pt-3 body-1 font-weight-medium">Nombre de Usuario: <span class="font-weight-bold">{{ device.nameUser}}</span>.</v-card-text>
              </div>
            <v-divider></v-divider>
            <v-spacer></v-spacer>
              <l-map :zoom="this.zoom" :center="coorde" class="style_map">
                <l-tile-layer :url="url" :attribution="attribution" />
                <l-marker :lat-lng="coorde">
                  <l-popup>
                    <div>
                      {{ device.name }}
                      <div>
                        <span v-if="device.name == 'post'"
                          >POSTPAGO</span
                        >
                        <span v-if="device.name == 'pre'"
                          >PREPAGO</span
                        >
                      </div>
                    </div>
                  </l-popup>
                </l-marker>
              </l-map>     
            <v-divider></v-divider>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    depressed
                    dark
                    :class="getColorStyle"
                    @click="dialog = false"
                    :to="{ name: 'DeviceID_loRaWan', params: { id: device.id } }"
                    style="border-bottom: 1px;"
                >
                    {{ textButton }}
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import moment from "moment";
import {latLng} from "leaflet";
import Info from "@/assets/img/information_icon.svg";
import Danger from "@/assets/img/danger_icon.svg";
import Alert from "@/assets/img/alert_icon.svg";
const tiposAlerta = Object.freeze({
    NORMAL: 'NORMAL',
    VERDE: 'VERDE',
    AMARILLA: 'AMARILLA',
    AZUL: 'AZUL',
    ROJA: 'ROJA'
});
const iconoAlerta = Object.freeze({
         NORMAL: '',
         VERDE: '',
         AMARILLA: Alert,
         AZUL: Info,
         ROJA: Danger
    });
const statusDevice = Object.freeze({
    Estado_1:"¡Alerta!",
    Estado_2:"¡Advertencia!",
    Estado_3:"¡Informacion!"
});
const coloresFondoAlerta = Object.freeze({
    NORMAL: '',
    VERDE: 'green darken-1',
    AMARILLA: 'yellow darken-1',
    AZUL: 'indigo darken-1',
    ROJA: 'red darken-2'
});

export default {
    name: 'AlertDialogWS',
    components:{
     LMap,
     LTileLayer,
     LPopup,
     LMarker,
    },
    data () {
        return {
            dialog: false,
            textButton: 'Aceptar',
            textTitle: 'Alerta',
            tipoAlerta: tiposAlerta.NORMAL,
            zoom: 17,
            device: {     
                id: "",
                idx: "",
                name: "",
                station: "", 
                data: "",
                lastUpdate: "",
                nameUser: "",

            },
            withPopup: latLng(this.latNum, this.longNum),
            currentCenter: latLng(this.latNum, this.longNum),
            url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
            attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            showMap: true,
            currentZoom: 11.5,
            showParagraph: false,
        }  
    },
    async mounted() {
        this.connectWebSocket();
    },
    methods: {
        connectWebSocket() {
            const urlObj = new URL(process.env.VUE_APP_BASE_URL);
            const host = urlObj.hostname;
            const port = urlObj.port;
            const hostAndPort = host + ((port) ? `:${port}` : '');

            const socket = new WebSocket(`ws://${hostAndPort}/websockets`);

            /* socket.onopen = function() {
                console.log('Conexión establecida con el servidor WebSocket');
            };

            socket.onclose = function() {
                console.log('Conexión cerrada con el servidor WebSocket');
            };

            socket.onerror = function(error) {
                console.error('Error de conexión:', error);
            }; */

            socket.onmessage = this.onMessageSocket;
        },
        onMessageSocket(event) {
            const { type, alert, device } = JSON.parse(event.data)

            if (type !== 'alert') {
                return;
            }

            this.tipoAlerta = tiposAlerta[alert.type]
            this.textTitle = alert.title
            this.device = device
            this.textButton = 'Ver dispositivo'
            this.dialog = true;
        },
      
    },
    computed: {
        getColorStyle(){
            return coloresFondoAlerta[this.tipoAlerta];
        },
        getIcon(){
            return iconoAlerta[this.tipoAlerta];
        },
        statusDevice(){
            return statusDevice[this.device.data];
        },
        getColorText(){
            let color = coloresFondoAlerta[this.tipoAlerta].split(" ");
           const result = color[0]+"--text text--"+color[1];
           return result
        },
        latNum() {
      let lat = Number(this.device.latitude);
      if(isNaN(lat)){
        lat = 0
      }
      return lat;
    },
    longNum() {
      let long = Number(this.device.longitude);
      if(isNaN(long)){
        long = 0
      }
      return long;
    },
    coorde() {
      let res = latLng(this.latNum, this.longNum);
      return res;
    },
    },
    filters:{
        formatDateShort: (value) => {
      if (value) {
        return moment(value)
          .locale("es")
          .format("YYYY-MM-DD h:mm A");
      }
      return "-";
    },
    }
}
</script>